import React from 'react';

import PrimitivePageSection from './PrimitivePageSection';

type Props = {
  children: React.ReactNode;
  dataTest?: string;
  isSuppressed?: boolean;
};

/**
 * Standardized styled section for all pages.
 * Max width of the content is set to 700px (margins/paddings are not counted).
 *
 * @param children - content
 * @param dataTest - optional dataTest
 * @param isSuppressed - optional isSuppressed, when true the section with have a grey background
 * @returns page section with max width and paddings
 */
const PageSection = ({ children, dataTest, isSuppressed }: Props): JSX.Element => (
  <PrimitivePageSection dataTest={dataTest} isSuppressed={isSuppressed}>
    {children}
  </PrimitivePageSection>
);

export default PageSection;
